<strong>Info</strong>
<app-form-element
    [formGroup]="formGroup"
    [formId]="'text'"
    [hideFloatingLabel]="true"
    [noLabel]="true"
    css="height: 100px !important;"
    [type]="FormTypes.TEXTAREA">
</app-form-element>

<button *ngIf="schoButton" (click)="saveContent()">Speichern</button>
